import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
    { title: 'Admin', isLink: false },
    { title: 'Action', href: '/admin/action' },
    {
        title: 'Action',
        prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
    },
];

const Title: PageTitle = {
    title: 'Action',
    prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
};

export { Breadcrumbs, Title };